export enum TenantInvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
}
